import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type RadioButtonProps = {
  checked?: boolean
  disabled?: boolean
  onChange?: (checked: boolean, e: React.MouseEvent<HTMLDivElement>) => void
} & ClassNameProps

export const RadioButton: React.FC<RadioButtonProps> = ({
  className,
  checked = false,
  disabled = false,
  onChange,
}) => {
  return (
    <Root
      onClick={(e) => {
        onChange?.(!checked, e)
      }}
      data-checked={checked}
      data-disabled={disabled}
      className={className}
    >
      <Indicator />
    </Root>
  )
}

const Root = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.2px solid var(--backgroundA-3);

  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out;

  &[data-checked='true'] {
    border-color: var(--primary-9);
  }
`

const Indicator = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  transition: background-color 0.15s ease-in-out;

  ${Root}[data-checked='true'] & {
    background-color: var(--text-12);
  }
`
